import React, { useEffect, useRef } from "react";
import styles from "./DataTable.module.scss";

type Props = {
  checked: boolean;
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
  "aria-label": string;
};

const SelectCheckbox = ({
  checked,
  indeterminate = false,
  onChange,
  "aria-label": ariaLabel,
}: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className={styles.checkbox}
      checked={checked}
      aria-label={ariaLabel}
      onClick={(event) => event.stopPropagation()}
      onChange={(event) => onChange(event.target.checked)}
    />
  );
};

export default SelectCheckbox;
